import AllJobs from "../components/jobs/AllJobs";

const Home = () => {
  return (
    <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8">
      <AllJobs />
    </div>
  );
};

export default Home;
